/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as d from "react";
import t from "prop-types";
import { Animation as f } from "./Animation.mjs";
const l = (r) => {
  const {
    appear: e = n.appear,
    enter: i = n.enter,
    exit: a = n.exit,
    transitionEnterDuration: o = n.transitionEnterDuration,
    transitionExitDuration: s = n.transitionExitDuration,
    children: p,
    ...c
  } = r, m = {
    transitionName: "fade"
  };
  return /* @__PURE__ */ d.createElement(
    f,
    {
      ...m,
      appear: e,
      enter: i,
      exit: a,
      transitionEnterDuration: o,
      transitionExitDuration: s,
      ...c
    },
    p
  );
}, n = {
  appear: !1,
  enter: !0,
  exit: !1,
  transitionEnterDuration: 500,
  transitionExitDuration: 500
};
l.propTypes = {
  children: t.oneOfType([t.arrayOf(t.node), t.node]),
  childFactory: t.any,
  className: t.string,
  component: t.node,
  id: t.string,
  style: t.any
};
export {
  l as Fade
};
